import React, { useContext } from 'react';
import { FormContext } from '../../FormContext';
import './InputAddRemove.css';

const InputAddRemove = ({ field_id, field_multiple_id, field_multiple_type }) => {

  const {
    handleAddField,
    handleRemoveLastField,
    formPageType,
    formStatus,
    formElements,
  } = useContext(FormContext);

  const handleAddButtonClick = () => {
    handleAddField(field_id);
  };

  if (!field_multiple_id || !formElements.pages) {
    return null;
  }

  const currentPart = formElements.pages
    .flatMap(page => page.parts || [])
    .find(part => part.fields?.some(field => field.field_id === field_id));

  if (!currentPart) {
    return null;
  }

  const groupFields = currentPart.fields.filter(field => field.field_multiple_id === field_multiple_id);
  const lastField = groupFields.reduce((latest, field) => {
    if (!latest || Number(field.field_multiple_index) >= Number(latest.field_multiple_index)) {
      return field;
    }
    return latest;
  }, null);
  const latestGroupIndex = Number(lastField?.field_multiple_index);
  const latestGroupFields = groupFields.filter(
    field => Number(field.field_multiple_index) === latestGroupIndex
  );

  if (
    field_id !== lastField?.field_id ||
    (formPageType !== 'user' && formStatus === 'Submitted')
  ) {
    return null;
  }

  return (
    <div className={`mt-3 text-right input-add-remove ${latestGroupFields.length % 2 !== 0 ? 'input-add-remove-span-columns' : ''}`}>
      <u className='text-success mr-3' onClick={handleAddButtonClick} style={{ cursor: 'pointer' }}>
        Add
      </u>
      <u className='text-danger' onClick={() => handleRemoveLastField(field_id)} style={{ cursor: 'pointer' }}>
        Remove
      </u>
    </div>
  );

};

export default InputAddRemove;